import { useLocalStorageState } from "hooks/useLocalStorageState";

import { type ListMode } from "./ListModeButton";

/**
 * The task list's layout (every occurrence, or one row per series), remembered
 * per grid like its column settings so it survives a refresh.
 */
export function useTaskListMode(persistenceKey?: string) {
  const [storedListMode, setListMode] = useLocalStorageState<ListMode>(
    `${persistenceKey ?? "tasks"}-list-mode`,
    { defaultValue: "series" }
  );
  const listMode: ListMode = storedListMode === "list" ? "list" : "series";
  return [listMode, setListMode] as const;
}
